module.exports = require("core-js-pure/stable/instance/includes");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/instance/includes.js
// module id = 559
// module chunks = 0 1